export default "__VITE_ASSET__DwsE4hgM__"